export default __webpack_public_path__ + "static/mental-health-806a2e5141bd8e65be6ab33a792f7eca.jpg";